import * as actionTypes from './actionsTypes';

export const setApplicationUpdates = (applicationUpdates) => {
  return {
    type: actionTypes.SETAPPLICATIONNUPDATES,
    data: applicationUpdates,
  };
};
